export default __webpack_public_path__ + "detectiveRobot.931942b.png";